<template>
  <div>
    <v-container class="">
      <v-row no-gutters>
        <v-col>
          <v-sheet
            id="js-enneagram-sheet"
            class="assessment-sheet top-sheet left-sheet"
          >
            <div class="assessment-name">Personality Style</div>
            <div class="d-flex justify-center">
              <img
                v-if="
                  getAssessmentByType('Enneagram') &&
                    getAssessmentByType('Enneagram').primary
                "
                @click="visitEnneagram()"
                height="200"
                class="cursor-pointer"
                :src="
                  `assessments/enneagram/type_${
                    getAssessmentByType('Enneagram').primary.number
                  }.svg`
                "
              />

              <img
                v-else
                @click="visitEnneagram()"
                height="200"
                class="cursor-pointer"
                src="assessments/enneagram/no_type.svg"
              />
            </div>
          </v-sheet>
        </v-col>
        <v-col>
          <v-sheet
            id="js-pro-d-sheet"
            class="assessment-sheet top-sheet cursor-pointer"
            @click="visitProD()"
          >
            <div class="assessment-name">Work Style</div>
            <div v-if="getAssessmentByType('Pro-D')">
              <div
                v-if="
                  getAssessmentByType('Pro-D').areas &&
                    getAssessmentByType('Pro-D').areas.length == 9
                "
              >
                <v-row justify="space-between">
                  <v-col class="pro-d-mini"
                    ><pro-d-chart
                      :stats="
                        getAssessmentByType('Pro-D').areas[
                          idsSortedByRank()[0] - 1
                        ]
                      "
                    ></pro-d-chart
                  ></v-col>
                  <v-col class="pro-d-mini"
                    ><pro-d-chart
                      :stats="
                        getAssessmentByType('Pro-D').areas[
                          idsSortedByRank()[1] - 1
                        ]
                      "
                    ></pro-d-chart
                  ></v-col>
                </v-row>
                <v-row justify="space-around">
                  <v-col class="pro-d-mini"
                    ><pro-d-chart
                      :stats="
                        getAssessmentByType('Pro-D').areas[
                          idsSortedByRank()[2] - 1
                        ]
                      "
                    ></pro-d-chart
                  ></v-col>
                </v-row>
              </div>
              <div
                v-else-if="
                  getAssessmentByType('Pro-D').areas &&
                    getAssessmentByType('Pro-D').areas.length > 2
                "
              >
                <v-row justify="space-between">
                  <v-col class="pro-d-mini"
                    ><pro-d-chart
                      :stats="getAssessmentByType('Pro-D').areas[0]"
                    ></pro-d-chart
                  ></v-col>
                  <v-col class="pro-d-mini"
                    ><pro-d-chart
                      :stats="getAssessmentByType('Pro-D').areas[1]"
                    ></pro-d-chart
                  ></v-col>
                </v-row>
                <v-row justify="space-around">
                  <v-col class="pro-d-mini"
                    ><pro-d-chart
                      :stats="getAssessmentByType('Pro-D').areas[2]"
                    ></pro-d-chart
                  ></v-col>
                </v-row>
              </div>
            </div>
          </v-sheet>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col>
          <v-sheet
            id="js-via-sheet"
            class="assessment-sheet left-sheet cursor-pointer"
            @click="visitVia()"
          >
            <div class="assessment-name">Character Strengths</div>
            <v-list
              class="via-list"
              v-if="
                getAssessmentByType('Via') && getAssessmentByType('Via').areas
              "
            >
              <v-list-item
                class="via-item"
                v-for="area in getAssessmentByType('Via').areas.slice(0, 5)"
                v-bind:key="area.id"
              >
                {{ area.name }}
              </v-list-item>
            </v-list>
          </v-sheet>
        </v-col>
        <v-col>
          <v-sheet
            id="js-4-mat-sheet"
            class="assessment-sheet cursor-pointer last-assessment-sheet"
            @click="visit4Mat()"
          >
            <div class="assessment-name">Learning Style</div>
            <four-mat-chart :data="get4MatAssessment()"></four-mat-chart>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import userMixin from "@/mixins/userMixin"
import ProDChart from "@/components/assessments/ProDChart"
import FourMatChart from "@/components/assessments/FourMatChart"

export default {
  mixins: [userMixin],
  components: {
    ProDChart,
    FourMatChart
  },
  data: function() {
    return {
      showUpdaters: false
    }
  },
  props: {
    userId: { type: Number },
    showEnneagramUpdate: { type: Boolean, default: false }
  },
  methods: {
    get4MatAssessment() {
      let ass = this.getAssessmentByType("4-Mat")

      return ass ? ass : {}
    },
    getAssessmentByType(type) {
      return this.assessments
        ? this.assessments.find(el => el.type == type)
        : {}
    },
    visitProD() {
      if (this.isMember()) {
        this.$router.push({ name: "ProDView" })
      } else {
        this.$router.push({
          name: "ProDViewMentor",
          params: { id: this.userId }
        })
      }
    },
    visitVia() {
      if (this.isMember()) {
        this.$router.push({ name: "ViaView" })
      } else {
        this.$router.push({
          name: "ViaViewMentor",
          params: { id: this.userId }
        })
      }
    },
    visitEnneagram() {
      if (this.isMember()) {
        this.$router.push({ name: "EnneagramView" })
      } else {
        this.$router.push({
          name: "EnneagramViewMentor",
          params: { id: this.userId }
        })
      }
    },
    visit4Mat() {
      if (this.isMember()) {
        this.$router.push({ name: "FourMatView" })
      } else {
        this.$router.push({
          name: "FourMatViewMentor",
          params: { id: this.userId }
        })
      }
    },
    byRank(a, b) {
      if (a.rank < b.rank) {
        return -1
      }
      if (a.rank > b.rank) {
        return 1
      }
      return 0
    },
    idsSortedByRank() {
      let areas = []
      if (
        this.getAssessmentByType("Pro-D") &&
        this.getAssessmentByType("Pro-D").areas
      ) {
        areas = this.getAssessmentByType("Pro-D").areas
      }
      let ranks = areas.map(el => {
        return {
          rank: parseInt(el.rank),
          id: parseInt(el.name.split("_")[0])
        }
      })
      return ranks.sort(this.byRank).map(el => el.id)
    }
  },
  computed: {
    ...mapGetters("assessments", ["getAssessmentsByUserId"]),
    assessments() {
      if (this.getAssessmentsByUserId(this.userId)) {
        return this.getAssessmentsByUserId(this.userId).assessments
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";

.assessment-sheet {
  height: 500px;
  min-width: 420px;
  max-width: 500px;
  border: 0px solid;
  @media only screen and (max-width: 1145px) and (min-width: 960px) {
    border-bottom: 2px solid $dark-yellow;
  }

  @media only screen and (max-width: 960px) {
    border: 0px !important;
  }
}

.last-assessment-sheet {
  border-bottom: 0px;
}

.top-sheet {
  @media only screen and (min-width: 1145px) {
    border-bottom: 2px solid $dark-yellow;
  }
  @media only screen and (max-width: 960px) {
    border-bottom: 2px solid $dark-yellow;
  }
}

.left-sheet {
  @media only screen and (min-width: 1145px) {
    border-right: 2px solid $dark-yellow;
  }

  @media only screen and (max-width: 960px) {
    border-right: 2px solid $dark-yellow;
  }
}

.assessment-name {
  font-size: 1.4em;
  font-style: italic;
  text-transform: uppercase;
  text-align: center;
  color: $dark-grey;
}

.cursor-pointer {
  cursor: pointer;
}

img {
  width: 400px;
  height: 400px;
}

.via-list {
  margin-top: 55px;
}

.via-item {
  font-size: 1.6em;
  justify-content: center;
  font-style: italic;
}

.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: $dark-grey !important;
}

.quadrant {
  font-size: 4em;
  color: $dark-grey;
  text-align: center;
  height: 100%;
}

.pro-d-mini {
  max-width: 220px;
}
</style>
